/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Template')
    .provider('template', function(){
        var basePath = '';

        this.setBasePath = function(path) {
            basePath = path;
        };

        this.$get = [function () {
            return function(path) {
               return basePath + path + '.html';
            }
        }];
    });
